import React from 'react';
import { CheckCircle2Icon, PhoneIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_TEL, CTAButton, SectionHeading, Section } from './shared';
// 05 — ANSWER-FIRST BLOCK · [SEO/GEO] [AEO] [Conversion]
const signals = ['Someone else — a driver, employer, business or occupier — contributed to what happened.', 'The injury led to medical costs, time away from work, or an ongoing loss.', 'The incident happened within a period where a claim may still be available.'];
export function AnswerFirst() {
  return <Section id="do-i-have-a-claim" className="bg-paper" data-id="element-29">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_0.9fr] lg:gap-16" data-id="element-30">
        <div data-id="element-31">
          <SectionHeading eyebrow="Answer first" title="Do I Have a Personal Injury Claim?" intro="You may have a personal injury claim if another person, employer, business or road user contributed to an injury that caused medical expenses, time away from work or an ongoing loss. Eligibility depends on what happened, when it happened and the law applying to the incident." data-id="element-32" />
          <p className="mt-4 max-w-2xl text-small text-slate/70" data-id="element-33">
            This is general information, not legal advice. Time limits and
            eligibility vary.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-34">
            <CTAButton href="#claim-router" className="px-6 py-3 leading-tight" data-id="element-35">
              <span className="flex flex-col text-left" data-id="element-36">
                <span data-id="element-37">I'm not sure</span>
                <span className="text-small font-normal opacity-90" data-id="element-38">
                  Help me work it out
                </span>
              </span>
            </CTAButton>
            <CTAButton href={PHONE_TEL} variant="secondary" className="px-6 py-3 leading-tight" data-id="element-39">
              <PhoneIcon aria-hidden="true" className="h-4 w-4 shrink-0" strokeWidth={1.75} data-id="element-40" />
              <span className="flex flex-col text-left" data-id="element-41">
                <span className="text-small font-normal opacity-80" data-id="element-42">Call</span>
                <span data-id="element-43">{PHONE_DISPLAY}</span>
              </span>
            </CTAButton>
          </div>
        </div>

        {/* Eligibility signals card */}
        <div className="relative rounded-card border border-ink/5 bg-paper p-7 shadow-card md:p-8" data-id="element-44">
          <p className="text-small font-semibold uppercase tracking-[0.14em] text-gold" data-id="element-45">
            Common signals of a claim
          </p>
          <ul className="mt-6 space-y-5" data-id="element-46">
            {signals.map(s => <li key={s} className="flex items-start gap-3" data-id="element-47">
                <CheckCircle2Icon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-forest" strokeWidth={1.75} data-id="element-48" />
                <span className="text-body text-ink" data-id="element-49">{s}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}